// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c823b35","667":"7af1f327"}[chunkId] + ".chunk.js";
};